import { qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import videoPlayerBlock from "@/lib/video-player-block";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  video: ".video-hero__video",
  videoPlayerVideo: "[data-video-player-block-video]",
  videoPlayerBlock: ".video-player-block",
};

section("video-hero", {
  videoHandler: null,
  onLoad() {
    const videoPlayerVideos = qsa(selectors.videoPlayerVideo, this.container);

    if (videoPlayerVideos.length) {
      this.videoPlayers = videoPlayerVideos.map(block =>
        videoPlayerBlock(block.closest(selectors.videoPlayerBlock))
      );
    }
    if (shouldAnimate(this.container)) {
      this.animateVideoHero = animateStandard(this.container, 3);
    }
  },

  onUnload() {
    this.videoPlayers && this.videoPlayers.forEach(button => button.unload());
    this.animateVideoHero?.destroy();
  },
});
